import { render, staticRenderFns } from "./AppNumberInput.vue?vue&type=template&id=8bbb4596&scoped=true"
import script from "./AppNumberInput.vue?vue&type=script&lang=js"
export * from "./AppNumberInput.vue?vue&type=script&lang=js"
import style0 from "./AppNumberInput.vue?vue&type=style&index=0&id=8bbb4596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbb4596",
  null
  
)

export default component.exports